export const SET_USER_LOGIN_STATE = "SET_USER_LOGIN_STATE"
export const SET_USER_AVATAR = "SET_USER_AVATAR"
export const SET_USER_NICKNAME = "SET_USER_NICKNAME"
export const SET_BARGAIN_LIST = "SET_BARGAIN_LIST"
export const SET_BARGAIN_INFO = "SET_BARGAIN_INFO"
export const SET_OPENER_FIRST_BARGAIN = "SET_OPENER_FIRST_BARGAIN"
export const SET_SUCCESS_BARGAIN_NUM = "SET_SUCCESS_BARGAIN_NUM"
export const GENERATE_BILL_UUID = "GENERATE_BILL_UUID"
export const SET_PROVIDE_LOGIN_STATE = "SET_PROVIDE_LOGIN_STATE"
export const SET_WECHAT_BIND_QQ = "SET_WECHAT_BIND_QQ"
export const SET_OPENER_FIRST_BARGAIN_DIALOG = "SET_OPENER_FIRST_BARGAIN_DIALOG"
/*大区角色
 */
export const SET_ZONE_INFO = "SET_ZONE_INFO"
export const SET_SELECTED_ZONE = "SET_SELECTED_ZONE"
export const SET_ROLE_INFO = "SET_ROLE_INFO"
export const SET_SELECTED_ROLE = "SET_SELECTED_ROLE"

export const SET_IOS_RECHARGE_ENABLE = "SET_IOS_RECHARGE_ENABLE"
